var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageMembershipPlusSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2674_66935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2674_66935",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 36,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.747 2.04338C21.1712 2.10313 21.7404 2.22031 22.3576 2.44847C23.1424 2.7387 23.8403 3.14534 24.432 3.65674C25.5083 4.58798 26.2706 5.97086 26.9592 7.30719C27.0352 7.45463 27.1104 7.60285 27.1864 7.7503C27.668 8.69317 28.1232 9.58328 28.6552 10.329C29.2685 11.1881 30.5736 11.9207 31.971 12.6579L32.2843 12.8224C33.4498 13.4347 34.6549 14.068 35.6095 14.8455C37.3737 16.2827 38.0002 18.5146 38.0002 19.9898C38.0002 21.85 37.3116 23.544 36.06 24.7601C35.1093 25.6843 33.5281 26.5108 31.9997 27.3093L31.7322 27.449C31.5856 27.5259 31.4391 27.6011 31.294 27.6756C30.4046 28.1327 29.6361 28.5269 29.0731 29.1447C28.3713 29.9145 27.6711 31.2392 26.9941 32.5204C26.6746 33.1241 26.3451 33.7488 26.0217 34.299C25.6084 35.0029 25.0361 35.8891 24.2769 36.5037C23.1199 37.4412 21.5217 38.0007 20.0033 38.0007C16.7588 38.0007 15.4033 36.2849 14.8248 35.5523L14.8093 35.5321C14.2037 34.7662 13.2219 32.9324 12.3557 31.3144L12.1751 30.9769C11.6633 30.0223 11.1848 29.1951 10.5008 28.7372C9.82075 28.2817 7.88365 27.1534 6.51496 26.4906C4.2196 25.3801 2.77879 23.7924 2.23209 21.7716C1.25889 18.1747 3.62094 15.3903 4.2576 14.8936C5.15093 14.1976 6.21796 13.6411 7.34703 13.0529C7.7937 12.8201 8.25587 12.5795 8.70176 12.3312C9.46792 11.9052 10.3357 11.4225 10.9002 10.8451C11.5446 10.1863 12.0905 9.15103 12.6186 8.14995C12.6713 8.04985 12.7861 7.83333 12.7861 7.83333C13.6236 6.25411 14.4146 4.76259 15.3661 3.83213C15.9035 3.30676 16.551 2.88072 17.29 2.5672C18.0399 2.24903 18.7533 2.10313 19.2612 2.0364C19.2612 2.0364 20.0638 1.94948 20.747 2.04338Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2674_66935)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.25781,
    y: -2.86285,
    width: 44.5136,
    height: 45.1176,
    fill: "url(#paint0_linear_2674_66935)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.456 26V14.144H20.344C21.2187 14.144 22.0027 14.2613 22.696 14.496C23.4 14.7307 23.9547 15.12 24.36 15.664C24.776 16.1973 24.984 16.9333 24.984 17.872C24.984 18.768 24.776 19.5093 24.36 20.096C23.9547 20.672 23.4053 21.0987 22.712 21.376C22.0293 21.6533 21.2613 21.792 20.408 21.792H18.824V26H16.456ZM18.824 19.92H20.248C21.0587 19.92 21.6613 19.7493 22.056 19.408C22.4613 19.0667 22.664 18.5547 22.664 17.872C22.664 17.1893 22.4507 16.7147 22.024 16.448C21.608 16.1707 20.9893 16.032 20.168 16.032H18.824V19.92Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2674_66935",
    x1: -2.25781,
    y1: -2.55801,
    x2: 42.2501,
    y2: 41.9556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23A0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52CEB4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2674_66935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageMembershipPlusSmall);
export default __webpack_public_path__ + "static/media/image__membership-plus--small.c262f60011e649b22e7a9d12899c3704.svg";
export { ForwardRef as ReactComponent };